import { rem } from 'polished';
import { makeStyles } from 'tss-react/mui';

export default makeStyles()(({ color }) => ({
  container: {
    backgroundColor: color.background.attention.emphasis,
    padding: `${rem(4)} ${rem(12)}`,
  },
}));
